import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AuthGuard } from '../auth/auth.guard';
import { SupportEmbedComponent } from './embed/embed.component';
import { SharedModule } from '../shared/shared.module';

const routes: Routes = [
  {
    path: 'support',
    component: SupportEmbedComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [SupportEmbedComponent],
  imports: [
    BrowserModule,
    RouterModule,
    SharedModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class SupportModule {}
